import { createSvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const FileIcon: FC<SvgIconProps> = createSvgIcon(
  <>
    <path
      d="M3 0.259094V23.6591H21V6.19349L20.7469 5.91221L15.3469 0.51222L15.0656 0.259094H3ZM4.8 2.05909H13.8V7.45912H19.2V21.8591H4.8V2.05909ZM15.6 3.35284L17.9063 5.65912H15.6V3.35284ZM7.5 9.25912V11.0591H16.5V9.25912H7.5ZM7.5 12.8591V14.6591H16.5V12.8591H7.5ZM7.5 16.4591V18.2591H16.5V16.4591H7.5Z"
      fill="currentColor"
    />
  </>,
  "File"
);

export default FileIcon;
